import { GlIcon, GlTooltipDirective } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { i18n } from '../constants';
export default {
    name: 'MergeRequestStatistics',
    i18n,
    components: {
        GlIcon
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        mergeRequest: {
            type: Object,
            required: true
        }
    }
};
